import './css/CajaLogin2.css';
import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import CONFIG from '../config';
import { fetchConfiguracion } from '../servicios/configuracionService.js';

const URL_LOGIN = `${CONFIG.API_URL}/login.php`;

function CajaLogin2({ acceder, configuracion: configuracionProp }) {
  const [error, setError] = useState(null);
  const [configLocal, setConfigLocal] = useState(null);
  const refUsuario = useRef(null);
  const refClave = useRef(null);

  const config = configuracionProp || configLocal;

  useEffect(() => {
    if (!configuracionProp) {
      obtenerConfiguracion();
    }
  }, [configuracionProp]);

  async function obtenerConfiguracion() {
    try {
      const data = await fetchConfiguracion();
      if (data) {
        setConfigLocal(data);
      }
    } catch (err) {
      console.error("Error al obtener configuracion en CajaLogin2:", err);
    }
  }

  const getImgUrl = (path) => {
    if (!path) return '';
    if (path.startsWith('http://') || path.startsWith('https://')) return path;
    if (path.startsWith('ConfigArchivos')) return `${CONFIG.API_URL}/${path}`;
    if (path.startsWith('img/')) return `${CONFIG.BASE_URL}${path}`;
    return `${CONFIG.BASE_URL}img/${path}`;
  };

  const handleLogin = (e) => {
    e.preventDefault();

    //datos
    const data = {
      'usuario': refUsuario.current.value,
      'clave': refClave.current.value
    };

    axios
      .post(URL_LOGIN, data)
      .then((res) => {

        if (res.data.conectado) {

          acceder(true);

          localStorage.setItem('loggedNoteAdapter', true);
          localStorage.setItem('loggeddatosuser', JSON.stringify(res.data.infoUser));
          localStorage.setItem('loggeduser', res.data.infoUser.usuario);
          localStorage.setItem('loggedUserId', res.data.infoUser.id);
          localStorage.setItem(
            'loggeduserNombre',
            res.data.infoUser.nombre + ' ' + res.data.infoUser.apellido
          );

          // Le avisamos a Flutter que se logeo (Esto en caso de que lo hayan hecho del celu)
          if (window.Flutter && typeof window.Flutter.postMessage === 'function') {
            const flutterMsg = {
              action: 'LOGIN',
              userId: res.data.infoUser.id,
              token: res.data.token
            };
            window.Flutter.postMessage(JSON.stringify(flutterMsg));
          }

        } else {
          setError(res.data.error);
          acceder(false);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fondoUrl = config?.imagen_fondo
    ? getImgUrl(config.imagen_fondo)
    : 'https://www.institutopetitdemeurville.com.ar/img/vista-aula-escuela.jpg';

  const logoUrl = config?.logo_solo
    ? getImgUrl(config.logo_solo)
    : 'https://www.institutopetitdemeurville.com.ar/img/logo_CSI.png';

  const colorPrincipal = config?.color_principal || '#d62c31';
  const colorSecundario = config?.color_secundario || '#35567E';

  return (
    <main className="caja-login-fondo py-2">
      <div className="d-flex justify-content-center">
        <div 
          className="contenedor-caja-login" 
          style={{ 
            backgroundImage: `url("${fondoUrl}")`,
            borderTop: `3px solid ${colorSecundario}`,
            borderLeft: `3px solid ${colorSecundario}`,
            borderRight: `3px solid ${colorSecundario}`,
            borderBottom: 'none',
            boxSizing: 'border-box'
          }}
        >
          <div className="cuerpo-login">
            <div className="cuerpo-login-circulo p-4 d-flex justify-content-center align-items-center">
              <img src={logoUrl} className="img-fluid" alt="Logo" />
            </div>
            <div className="cuerpo-login-trapecio"></div>
            <div 
              className="cuerpo-login-cuadrado"
              style={{
                borderLeft: `3px solid ${colorSecundario}`,
                borderRight: `3px solid ${colorSecundario}`,
                borderBottom: `3px solid ${colorSecundario}`,
                borderTop: 'none',
                width: '400px',
                marginLeft: '-3px',
                boxSizing: 'border-box'
              }}
            >
              <form onSubmit={handleLogin} className="login-wrapper my-auto w-100 text-center">
                <h1
                  className="login-title"
                  style={{
                    color: colorPrincipal
                  }}>
                    Ingreso
                </h1>

                {error && <div className="alerta text-danger">{error}</div>}

                <Form.Group className="mb-3">
                  <div className="fuente text-start text-dark">Usuario</div>
                  <div className="input-group input-icon-group">
                    <span className="icon-wrapper">
                      <i className="fa-solid fa-user icon-style"></i>
                    </span>
                    <Form.Control
                      className="input"
                      type="text"
                      placeholder="Usuario"
                      required
                      ref={refUsuario}
                    />
                  </div>
                </Form.Group>

                <Form.Group className="mb-3">
                  <div className="fuente text-start text-dark">Contraseña</div>
                  <div className="input-group input-icon-group">
                    <span className="icon-wrapper">
                      <i className="fa-solid fa-lock icon-style"></i>
                    </span>
                    <Form.Control
                      className="input"
                      type="password"
                      placeholder="Ingrese Contraseña"
                      required
                      ref={refClave}
                    />
                  </div>
                </Form.Group>

                <button 
                  className="login-btn" 
                  type="submit"
                  style={{
                    backgroundColor: colorPrincipal,
                    borderColor: colorSecundario,
                    '--btn-bg': colorPrincipal,
                    '--btn-secundario': colorSecundario
                  }}
                >
                  ingresar
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default CajaLogin2;
